import { render, staticRenderFns } from "./noticeManageModal.vue?vue&type=template&id=6a5f0b3f&scoped=true&"
import script from "./noticeManageModal.vue?vue&type=script&lang=js&"
export * from "./noticeManageModal.vue?vue&type=script&lang=js&"
import style0 from "./noticeManageModal.vue?vue&type=style&index=0&id=6a5f0b3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5f0b3f",
  null
  
)

export default component.exports